// Persists the in-progress guest state across pages (onboarding -> trial session -> save).
const KEY = "continua_guest";

export function readGuest() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function writeGuest(patch) {
  const cur = readGuest();
  const next = { ...cur, ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearGuest() {
  localStorage.removeItem(KEY);
}
